export const EMBA_API_HOST = (import.meta.env.VITE_EMBA_API_HOST ||
  'http://localhost:18083') as string;
export const SSO_AUTH_URL = `${EMBA_API_HOST}/emba/learners/sessions/new`;
export const GLOPLA_PARTICIPANT_HOST =
  import.meta.env.VITE_GLOPLA_PARTICIPANT_HOST ||
  ('https://digital.globis.co.jp' as string);
export const HIGHLIGHT_WORDS_FOR_QUESTION = [
  '不適切な',
  '適切でない',
  '正しくない',
  '該当しない',
  '当てはまらない',
  'あてはまらない',
  '適当でない',
  'ふさわしくない',
  '間違っている',
  '誤っている',
];

export const DEPLOYMENT_ENV = import.meta.env.VITE_DEPLOYMENT_ENV as string;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
export const ERROR_TEST_PAGE_ENABLED = import.meta.env
  .VITE_ERROR_TEST_PAGE_ENABLED as string | undefined;

export const INQUIRY_URL = 'https://globis.zendesk.com/hc/ja';
export const MICROPHONE_SETTING_GUIDE_URL =
  'https://globis.zendesk.com/hc/ja/articles/52735128747801';

export const AI_POLICY_URL = `${GLOPLA_PARTICIPANT_HOST}/term/9999`;

export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY as
  | string
  | undefined;

export const VITE_GTM_ID = import.meta.env.VITE_GTM_ID as string | undefined;
